import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import usePropertiesWithOptions from 'flow-doctor-lib/hooks/usePropertiesWithOptions';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentPropertyFilterRenderer = ({
  reEnrollmentTriggerSet,
  objectTypeId
}) => {
  const {
    propertyWrapper,
    labelsForOptions,
    loading: propertyMapLoading,
    error: propertyMapError
  } = usePropertiesWithOptions({
    portalId: PortalIdParser.get(),
    propertyName: reEnrollmentTriggerSet[0].id,
    objectTypeId,
    rawOptions: [reEnrollmentTriggerSet[1] && reEnrollmentTriggerSet[1].id.toString()]
  });
  if (!propertyMapError && (propertyMapLoading || !propertyWrapper)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return reEnrollmentTriggerSet.length === 1 ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.propertyKnown",
    options: {
      propertyName: propertyWrapper ? propertyWrapper.property.label : reEnrollmentTriggerSet[0].id
    }
  }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.propertyValue",
    options: {
      propertyName: propertyWrapper ? propertyWrapper.property.label : reEnrollmentTriggerSet[0].id,
      propertyValue: labelsForOptions[reEnrollmentTriggerSet[1].id.toString()] || reEnrollmentTriggerSet[1].id
    }
  });
};
export default ClassicReenrollmentPropertyFilterRenderer;